<template lang="pug">
.code-mirror(
    :class="{ disabled }"
    :style="style"
    ref="container"
)
    // FontAwesomeIcon.resize-icon(icon="grip-vertical")
    .editor(ref="editor")
</template>

<script>
import '@fontsource/fira-code'
// import '@fontsource/monaspace-krypton';

import { EditorView, basicSetup } from 'codemirror';
import { EditorState, Compartment } from '@codemirror/state';

// import {
//     foldCode,
//     unfoldCode,
//     foldGutter,
//     defaultHighlighter,
//     bracketMatching,
// } from "@codemirror/language";
// import {
//     baseKeymap,
//     indentSelection,
//     indentWithTab,
//     history,
//     redo,
//     redoSelection,
//     undo,
//     undoSelection,
//     defaultKeymap,
// } from "@codemirror/commands";
// import { autocomplete, closeBrackets } from '@codemirror/autocomplete';
// import { lineNumbers, highlightActiveLine, keymap } from '@codemirror/view';

import { keymap } from '@codemirror/view';
import { indentWithTab } from "@codemirror/commands";

import { javascript, esLint } from '@codemirror/lang-javascript';
import { html } from '@codemirror/lang-html';
import { css } from '@codemirror/lang-css';

import Linter from 'eslint4b-prebuilt';
import { linter, openLintPanel } from '@codemirror/lint';

import { parser as twigParser } from "@/codemirror/twig-parser.js"
import { LRLanguage, foldNodeProp, foldInside, indentNodeProp } from "@codemirror/language"
import { parseMixed } from "@lezer/common"

import { parser as htmlParser } from "@lezer/html"
import { parser as jsParser } from "@lezer/javascript"

// import { nord } from 'cm6-theme-nord'
// import { basicDark } from 'cm6-theme-basic-dark'
// import { basicLight } from 'cm6-theme-basic-light'
// import { solarizedDark } from 'cm6-theme-solarized-dark'
// import { solarizedLight } from 'cm6-theme-solarized-light'
// import { materialDark } from 'cm6-theme-material-dark'
import { oneDark } from '@codemirror/theme-one-dark'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'CodeMirror',
    props: {
        value: {
            default: undefined
        },
        language: {
            type: String,
            required: true,
            validator(value) {
                // The value must match one of these strings
                return ['html', 'twig', 'js', 'javascript', 'css'].includes(value)
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
    },
    data () {
        return {
            content: this.value,
            editor: null,
            compartments: {
                readonly: new Compartment(),
                editable: new Compartment(),
            },
        }
    },
    components: {
        FontAwesomeIcon
    },
    watch: {
        value(value) {
            if (value !== this.editor.state.doc.toString()) {
                const transaction = this.editor.state.update({
                    changes: {
                        from: 0,
                        to: this.editor.state.doc.length,
                        insert: value,
                    }
                });

                if (transaction) {
                    this.editor.dispatch(transaction);
                }
            }

            if (!this.disabled) {
                this.$emit('input', value);
            }
        },
        disabled(value) {
            this.editor.dispatch({
                effects: this.compartments.readonly.reconfigure(EditorState.readOnly.of(value)),
            })
            this.editor.dispatch({
                effects: this.compartments.editable.reconfigure(EditorView.editable.of(!value)),
            })

            if (value) {
                const timer = setInterval(() => {
                    this.editor.focus();
                    if (this.editor.hasFocus) clearInterval(timer);
                }, 500);
            }
        }
    },
    computed: {
        style() {
            if (!this.editor) return {}
            return {
                maxHeight: _.get(this.editor, 'viewState.editorHeight') + 8 + 'px'
            }
        }
    },
    methods: {
        handleResize() {
            this.editor.requestMeasure()
        },
        async initialize() {
            if (this.editor) {
                this.editor.destroy();
                await this.$nextTick();
            }

            const updateListenerExtension = EditorView.updateListener.of((update) => {
                if (update.docChanged) {
                    this.content = update.state.doc.toString();
                    this.$emit('input', this.content);
                }
            })

            let extensions = [
                basicSetup,
                // lineNumbers(),
                // history(),
                // foldGutter(),
                // // defaultHighlighter,
                // highlightActiveLine(),
                oneDark,
                // bracketMatching(),
                // closeBrackets(),
                updateListenerExtension,
                // keymap.of(defaultKeymap),
                keymap.of([
                    indentWithTab,
                    // {
                    //     key: 'Mod-z',
                    //     run: undo,
                    //     shift: redo,
                    // },
                    // {
                    //     key: 'Mod-u',
                    //     run: undoSelection,
                    // },
                    // {
                    //     key: 'Mod-Alt-u',
                    //     mac: 'Mod-Shift-u',
                    //     run: redoSelection,
                    // },
                    // {
                    //     key: 'Shift-Tab',
                    //     run: indentSelection,
                    // },
                    // // {
                    // //     key: 'Mod-Alt-[',
                    // //     run: foldCode,
                    // // },
                    // // {
                    // //     key: 'Mod-Alt-]',
                    // //     run: unfoldCode,
                    // // },
                    // {
                    //     key: 'Shift-Mod-m',
                    //     run: openLintPanel,
                    // }
                ]),
            ];

            if (this.disabled) {
                extensions = [
                    this.compartments.readonly.of(EditorState.readOnly.of(true)),
                    this.compartments.editable.of(EditorView.editable.of(false)),
                    ...extensions,
                ]
            }

            switch (this.language) {
                case 'html':
                    extensions = [
                        ...extensions,
                        html(),
                    ]
                    break;

                case 'twig':
                    const mixedTwigParser = twigParser.configure({
                        props: [
                            // Add basic folding/indent metadata
                            foldNodeProp.add({Conditional: foldInside}),
                            indentNodeProp.add({Conditional: cx => {
                                let closed = /^\s*\{% endif/.test(cx.textAfter)
                                return cx.lineIndent(cx.node.from) + (closed ? 0 : cx.unit)
                            }})
                        ],
                        wrap: parseMixed(node => {
                            return node.type.isTop ? {
                                parser: htmlParser,
                                overlay: node => node.type.name == 'Text'
                            } : null
                        })
                    })
                    const twigLanguage = LRLanguage.define({ parser: mixedTwigParser })

                    const twig = () => {
                        return [
                            twigLanguage,
                            html().support
                        ]
                    }

                    extensions = [
                        ...extensions,
                        // twigLanguage,
                        twig(),
                    ]
                    break;

                case 'js':
                case 'javascript':
                    extensions = [
                        ...extensions,
                        javascript(),
                        linter(esLint(new Linter())),
                    ]
                    break;

                case 'css':
                    extensions = [
                        ...extensions,
                        css(),
                    ]
                    break;
            }

            this.editor = new EditorView({
                doc: this.value,
                extensions,
                parent: this.$refs.editor,
            })

            // this.editor = new EditorView({
            //     state: EditorState.create({
            //         doc: this.value,
            //         extensions: [basicSetup, html()],
            //     }),
            //     parent: this.$refs.editor,
            // })

            // const view = new EditorView({
            //     doc: this.value,
            //     extensions: [
            //         basicSetup,
            //         oneDark,
            //         keymap.of([indentWithTab]),
            //         // javascript(),
            //         html(),
            //     ],
            //     parent: this.$refs.editor,
            // });
        }
    },
    mounted() {
        this.initialize();

        const observer = new ResizeObserver(this.handleResize);
        observer.observe(this.$refs.container);
    },
    beforeDestroy() {
        this.editor.destroy();
    }
}
</script>

<style lang="sass" scoped>
.code-mirror
    position: relative
    resize: vertical
    overflow: auto
    border-radius: 6px
    isolation: isolate
    min-height: 138px
    height: 26rem
    // &::-webkit-resizer
    //     // background: silver
    //     // border: 1px solid darkgray
    //     width: 16px
    //     height: 22px
    &::v-deep
        .cm-editor
            padding: 4px 4px
            .cm-content *,
            .cm-lineNumbers *
                // font-family: 'Monaspace Krypton'
                font-family: 'Fira Code'
        .cm-editor,
        .ͼ1 .cm-scroller
            border-radius: 6px
            min-height: 130px
        .cm-gutter.cm-foldGutter
            .cm-gutterElement
                span
                    visibility: hidden
                    &:before
                        visibility: visible
                    &[title="Fold line"]:before
                        // content: url('~@/assets/icons/hero/chevron-down.svg')
                        content: '▾'
                    &[title="Unfold line"]:before
                        // content: url('~@/assets/icons/hero/chevron-right.svg')
                        // content: '▸'
                        content: '···'
                &[style*="visibility: hidden"] span
                    &:before
                        visibility: hidden
    &.disabled
        filter: contrast(0.8) brightness(1.2) saturate(40%)
        opacity: 0.8
        &::v-deep
            .cm-activeLine
                background: transparent !important
    // .resize-icon
    //     position: absolute
    //     right: 4px
    //     bottom: 4px
    //     z-index: 10
    //     color: $color-grey-text
</style>
